import {delegableRole} from '../lib/project-permissions.mjs';
import {responseVersion} from '../lib/http-version.js';
const el=(tag,text,parent,attrs={})=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;Object.assign(n,attrs);parent?.append(n);return n;};
const btn=(text,parent,fn,cls='btn btn-sm')=>{const b=el('button',text,parent,{type:'button',className:cls});b.onclick=fn;return b;};
const option=(parent,text,value)=>el('option',text,parent,{value});
let membersSeq=0,membersGuard=()=>true;
export function confirmLeaveMembers(){return membersGuard();}
export function releaseMembersGuard(){membersGuard=()=>true;membersSeq++;}

export async function openProjectMembers(projectId){
 const seq=++membersSeq,url=`/api/auth/projects/${projectId}`;
 const root=document.getElementById('projectMembersPage');
 if(!root)throw new Error('找不到成員頁面');
 if(!projectId){root.replaceChildren();el('p','請先選擇專案',root);return;}
 let data,etag,busy=false,editable=false,target=null,searchToken=0;
 const roleDrafts=new Map();let policyDraft=null;
 const alive=()=>seq===membersSeq;
 root.replaceChildren();
 const header=el('header',null,root,{className:'members-header'}),heading=el('div',null,header);
 const title=el('h3','成員清單',heading,{id:'membersDialogTitle'}),project=el('p','讀取專案…',heading);
 root.setAttribute('aria-labelledby','membersDialogTitle');
 const status=el('p','讀取成員…',root,{className:'members-status',role:'status'});
 const content=el('div',null,root,{className:'members-content'});
 const controls=el('fieldset',null,content,{className:'members-controls'});
 const message=(text,error=false)=>{status.textContent=text;status.classList.toggle('is-error',error);};
 const dirty=()=>roleDrafts.size>0||!!username?.value||!!policyDraft&&JSON.stringify([...policyDraft].sort())!==JSON.stringify([...(data?.policy?.roleIds||[])].sort());
 membersGuard=()=>{if(!alive())return true;if(busy){message('操作處理中，請稍候');return false;}if(dirty()&&!confirm('尚有未保存的修改，確定要放棄並離開？'))return false;return true;};
 const toolbar=el('div',null,controls,{className:'members-toolbar'});
 const searchLabel=el('label','搜尋成員',toolbar);
 const search=el('input',null,searchLabel,{type:'search',placeholder:'姓名或帳號'});
 const roleLabel=el('label','角色篩選',toolbar),roleFilter=el('select',null,roleLabel);
 const stateLabel=el('label','帳號狀態',toolbar),stateFilter=el('select',null,stateLabel);
 option(stateFilter,'全部狀態','all');option(stateFilter,'已啟用','enabled');option(stateFilter,'已停用','disabled');
 const reset=btn('清除篩選',toolbar,()=>{search.value='';roleFilter.value='all';stateFilter.value='all';renderRows();search.focus();});
 const count=el('p','',controls,{className:'members-count'}),list=el('div',null,controls,{className:'members-list'});
 const addSection=el('details',null,controls,{className:'members-add'});
 el('summary','加入成員',addSection);
 const form=el('form',null,addSection,{className:'project-member-form'});
 const accountLabel=el('label','既有帳號',form),username=el('input',null,accountLabel,{placeholder:'輸入完整登入帳號',required:true,maxLength:64,autocomplete:'off'});
 username.setAttribute('aria-label','既有帳號');
 const query=btn('查詢帳號',form,lookup);
 const candidate=el('p','',form,{className:'members-candidate',role:'status',id:'membersCandidate'});
 username.setAttribute('aria-describedby','membersCandidate');
 const addRoleLabel=el('label','業務角色',form),addRole=el('select',null,addRoleLabel);addRole.setAttribute('aria-label','業務角色');
 const add=el('button','加入專案角色',form,{type:'submit',className:'btn btn-primary',disabled:true});
 const policySection=el('details',null,controls,{className:'members-policy'});
 el('summary','可委派角色（僅全站管理者）',policySection);
 const policyList=el('div',null,policySection,{className:'members-policy-list'});
 const savePolicy=btn('儲存可委派角色',policySection,()=>mutate('policy.set',{roleIds:[...(policyDraft||data.policy.roleIds)]},()=>{policyDraft=null;}));
 async function request(path,options={}){
  const response=await fetch(path,options),value=await response.json();
  if(!response.ok)throw Object.assign(new Error(value.error||'專案設定讀取失敗'),{status:response.status});
  return {value,etag:responseVersion(response)};
 }
 async function load(){
  const result=await request(url);data=result.value;etag=result.etag;
  editable=!!window.dcmsAuth.admin&&Array.isArray(data.availableRoles);
 }
 function assigned(user){return !!user&&data.bindings.some(b=>b.userId===user.id&&b.scope.type==='project'&&!['system-admin','project-manager'].includes(b.roleId));}
 function syncAdd(){add.disabled=!target||assigned(target)||!data.assignableRoles.some(r=>r.id===addRole.value);}
 async function lookup(){
  const q=username.value.trim(),token=++searchToken;target=null;syncAdd();
  if(!q){candidate.textContent='請輸入完整登入帳號';username.focus();return;}
  query.disabled=true;candidate.textContent='查詢中…';
  try{
   const result=await request(url+'/candidates?q='+encodeURIComponent(q));
   if(!alive()||token!==searchToken)return;
   target=result.value.users[0]||null;
   const text=assigned(target)?'此帳號已有專案業務角色，請於清單變更角色':target?`已找到：${target.displayName}（${target.username}）`:'找不到啟用的帳號，請由全站管理者先建立。';
   candidate.textContent=text;message(text);syncAdd();
  }catch(e){if(token===searchToken){candidate.textContent=e.message;message(e.message,true);}}
  finally{if(alive())query.disabled=false;}
 }
 username.oninput=()=>{++searchToken;target=null;candidate.textContent='';syncAdd();};
 addRole.onchange=syncAdd;
 form.onsubmit=event=>{event.preventDefault();if(add.disabled)return;mutate('member.add',{userId:target.id,roleId:addRole.value},()=>{username.value='';target=null;candidate.textContent='';addSection.open=false;});};
 async function mutate(operation,payload,onSuccess=()=>{}){
  if(busy||!editable)return;
  const top=content.scrollTop,focusBinding=document.activeElement?.closest('[data-binding-id]')?.dataset.bindingId;
  busy=true;controls.disabled=true;root.setAttribute('aria-busy','true');message('保存中…');
  try{
   const result=await request(url,{method:'POST',headers:{'Content-Type':'application/json','If-Match':etag},body:JSON.stringify({operation,...payload})});
   if(!alive())return;
   data=result.value;etag=result.etag;onSuccess();render();message('已保存');
   window.dispatchEvent(new Event('dcms-project-settings-changed'));
  }catch(e){
   if(!alive())return;
   message(e.status===412?'資料已由其他人更新，已重新載入；請確認保留的修改後再保存。':e.message,true);
   if([412,403,404].includes(e.status)){
    try{await load();render();}
    catch(refreshError){if([403,404].includes(refreshError.status)){editable=false;controls.replaceChildren();message(refreshError.message,true);}}
   }
  }finally{
   busy=false;controls.disabled=false;root.removeAttribute('aria-busy');content.scrollTop=top;
   if(alive()){const row=focusBinding&&list.querySelector(`[data-binding-id="${CSS.escape(focusBinding)}"]`);(row?.querySelector('select,button')||search).focus({preventScroll:true});}
  }
 }
 function render(){
  title.textContent=editable?'成員管理':'成員清單';project.textContent=data.project.name;
  const oldRole=roleFilter.value;roleFilter.replaceChildren();option(roleFilter,'全部角色','all');
  for(const role of data.roles)option(roleFilter,role.name,role.id);
  roleFilter.value=[...roleFilter.options].some(o=>o.value===oldRole)?oldRole:'all';
  // 唯讀清單不保留管理表單或候選查詢控制項。
  if(!editable){addSection.remove();policySection.remove();}
  else{
   const selected=addRole.value;addRole.replaceChildren();option(addRole,'選擇業務角色','');
   for(const role of data.assignableRoles)option(addRole,role.name,role.id);
   addRole.value=data.assignableRoles.some(r=>r.id===selected)?selected:'';syncAdd();
   if(!data.assignableRoles.length)candidate.textContent='尚未開放可委派的業務角色';
   policyList.replaceChildren();
   for(const role of data.availableRoles){
    const label=el('label',null,policyList),check=el('input',null,label,{type:'checkbox',value:role.id,checked:(policyDraft||new Set(data.policy.roleIds)).has(role.id)});
    el('span',role.name,label);
    check.onchange=()=>{policyDraft||=new Set(data.policy.roleIds);check.checked?policyDraft.add(role.id):policyDraft.delete(role.id);};
   }
  }
  renderRows();
 }
 function renderRows(){
  if(!data)return;
  const q=search.value.trim().toLowerCase();reset.hidden=!q&&roleFilter.value==='all'&&stateFilter.value==='all';
  const visible=data.bindings.filter(b=>{
   const user=data.users.find(u=>u.id===b.userId);
   return (!q||`${user?.displayName||''} ${user?.username||''}`.toLowerCase().includes(q))&&(roleFilter.value==='all'||b.roleId===roleFilter.value)&&(stateFilter.value==='all'||(stateFilter.value==='enabled'?user?.enabled===true:user?.enabled===false));
  });
  const people=new Set(visible.map(b=>b.userId)).size,total=new Set(data.bindings.map(b=>b.userId)).size;
  count.textContent=`成員 ${people} 人${people!==total?`／共 ${total} 人`:''} · ${visible.length} 筆指派`;
  list.replaceChildren();
  if(!visible.length){el('p',data.bindings.length?'沒有符合條件的成員，請調整搜尋或篩選。':'尚無專案成員。',list,{className:'members-empty'});return;}
  const table=el('table',null,list,{className:'project-members-table'}),head=el('tr',null,el('thead',null,table));
  for(const text of ['成員','角色','範圍','帳號狀態',...(editable?['操作']:[])])el('th',text,head,{scope:'col'});
  const rows=el('tbody',null,table);
  for(const b of visible){
   const user=data.users.find(u=>u.id===b.userId),role=data.roles.find(r=>r.id===b.roleId),row=el('tr',null,rows);row.dataset.bindingId=b.id;
   const cell=label=>{const td=el('td',null,row);td.dataset.label=label;return td;};
   const who=cell('成員');el('strong',user?.displayName||'歷史帳號',who);el('span',`@${user?.username||b.userId}`,who,{className:'members-account'});
   el('span',role?.name||b.roleId,cell('角色'));
   const scope=b.scope.type==='project'?'整個專案':'專案子目錄';el('span',scope,cell('範圍'));
   el('span',user?(user.enabled?'已啟用':'已停用'):'歷史帳號',cell('帳號狀態'),{className:`members-badge${user&&!user.enabled?' is-disabled':''}`});
   if(!editable)continue;
   const actions=cell('操作');actions.className='members-row-actions';
   if(delegableRole(role)&&b.scope.type==='project'){
    const picker=el('select',null,actions);picker.setAttribute('aria-label',`變更 ${user?.username||b.userId} 的業務角色`);
    if(!data.assignableRoles.some(r=>r.id===b.roleId))option(picker,role.name,role.id);
    for(const r of data.assignableRoles)option(picker,r.name,r.id);
    const draft=roleDrafts.get(b.id);picker.value=[...picker.options].some(o=>o.value===draft)?draft:b.roleId;
    if(draft&&!data.assignableRoles.some(r=>r.id===draft))el('span','原選角色已不可用，請重新選擇。',actions,{className:'members-inline-error'});
    const update=btn('變更角色',actions,()=>mutate('member.update',{bindingId:b.id,roleId:picker.value},()=>roleDrafts.delete(b.id)));
    const sync=()=>{update.disabled=picker.value===b.roleId||!data.assignableRoles.some(r=>r.id===picker.value);};
    picker.onchange=()=>{picker.value===b.roleId?roleDrafts.delete(b.id):roleDrafts.set(b.id,picker.value);sync();};sync();
   }
   if(delegableRole(role))btn('解除此角色',actions,()=>{if(confirm(`解除 ${user?.displayName||'歷史帳號'}（${user?.username||b.userId}）的「${role.name}」／${scope}？只解除此筆指派，其他角色及管理者任命不受影響。`))mutate('member.remove',{bindingId:b.id},()=>roleDrafts.delete(b.id));},'btn btn-sm members-remove');
   else el('span','由全站管理者任命',actions,{className:'members-readonly'});
  }
 }
 search.oninput=renderRows;roleFilter.onchange=renderRows;stateFilter.onchange=renderRows;
 try{await load();if(!alive())return;render();message('');search.focus();}
 catch(e){message(e.message,true);controls.replaceChildren();}
}
